import { AfterViewInit, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService, Logger } from '@patientlynk3/services';
import { SwUpdate } from '@angular/service-worker';
import { environment } from '@patientlynk3/environment';
import { delay, filter, first, take } from 'rxjs/operators';
import { PatientlynkIntroModalComponent } from '@patientlynk3/components/patientlynk-intro-modal/patientlynk-intro-modal.component';
import { SettingsService } from '@patientlynk3/services/settings';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { theme } from '@theme/.';
import { Capacitor } from '@capacitor/core';

// import * as packageInfo from '@root/package.json';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements AfterViewInit {
  env = {
    name: environment.name,
    build : document.lastModified,
    debug: environment.production,
    version: 3,
    showVersion: false,
    update: false
  };

  theme = theme
  loading = true;

  isNative = Capacitor.isNativePlatform();

  constructor(private auth: AuthService, private router: Router, private route: ActivatedRoute,
              private swUpdate: SwUpdate, private settings: SettingsService, private modal: NgbModal) { }

  ngAfterViewInit() {
    const token = this.route.snapshot.queryParamMap.get('token');
    const url = this.route.snapshot.queryParamMap.get('url') || '';

    if (!token) {
      this.loading = false;
    } else {
      this.transferSession(token, url);
    }

    if (this.auth.isLoggedIn()) {
      this.router.navigate([url || '/home']);
      return;
    }

    if (this.swUpdate.isEnabled) {
      this.swUpdate.checkForUpdate();
    }

    this.swUpdate.versionUpdates.pipe(take(1))
      .subscribe((_) => this.env.update = true);
  }

  transferSession(token: string, url: string) {
    this.settings.select('patientLynkOutroPopup').pipe(
      delay(1000),
      first(),
      filter(popupSettings => !popupSettings.dontShow)
    ).subscribe(
      () => this.modal.open(PatientlynkIntroModalComponent, {
        centered: true
      }),
    );

    this.auth.transferSession(token).subscribe(
      () => this.router.navigate([url || '/home']),
      err => {
        this.loading = false;
        Logger.error('Could not create new session using refresh token.', err);
      }
    );
  }

  triggerSwUpdate() {
    if (!environment.production) {
      this.swUpdate.activateUpdate();
      this.swUpdate.activateUpdate().then(() => window.location.reload());
    }
  }
}
